import './style.css'
import React,{ useState } from 'react'

function App() {
  // let name = " ";
  const [name,setName] = useState("")

  return <>
  
  <div>
    <form> 

      <input type="text" placeholder="Enter Any Here..."  onChange={(e)=> setName(e.target.value)}/>
      {/* <input type="password" placeholder="Enter password here..." /> */}
      <div>
      <h1>typing... =  {name}</h1>
      </div>

      {/* <button onClick={()=>console.log(name)}>Enter hit</button> */}
    </form>
  </div>
  
  
  
  
  </>
}

export default App;
